// src/misc/america250/locationLinks.js

/**
 * Map of display location name -> Google Maps URL
 * Keys should match the sheet "Location" values exactly.
 */
export const LOCATION_MAP_LINKS = {
  "Riverfront Community Center":
    "https://www.google.com/maps?q=300+Welles+St,+Glastonbury,+CT+06033",

  "Gideon Welles School":
    "https://www.google.com/maps?q=1029+Neipsic+Rd,+Glastonbury,+CT+06033",

  "Welles-Turner Memorial Library":
    "https://www.google.com/maps?q=2407+Main+St,+Glastonbury,+CT+06033",
};
